import { render, staticRenderFns } from "./widget_main_tabs.vue?vue&type=template&id=676c1f3a&scoped=true&"
import script from "./widget_main_tabs.vue?vue&type=script&lang=js&"
export * from "./widget_main_tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676c1f3a",
  null
  
)

/* custom blocks */
import block0 from "./widget_main_tabs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports